import React, { useEffect, useState } from "react";
import styles from "./cardRecordTrainedUsers.module.css";
import { ProgressBar } from "react-loader-spinner";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import { useSelector } from "react-redux";
import {
  columnsRecordTrainedUsersTable,
  getOptionsInputsRecordTrainedUsers,
  setOptionsInputsRecordTrainedUsers,
} from "./optionsRecordTrainedUsersTable";
import add_icon from "../../../../resourсes/add-icon.svg";
import edit_icon from "../../../../resourсes/edit-icon.svg";
import { captionsForModalWindow } from "./optionsForModalWindowTrainedUser";
import SelectWithSearch from "../../../../components/GeneralComponents/componentsForForm/selectWithSearch/SelectWithSearch";
import InputForForm from "../../../../components/GeneralComponents/componentsForForm/inputForForm/InputForForm";
import EditableTableForKnoweledgeTest from "../../../../components/knowledgeTestComponents/commonComponents/EditableTableForKnoweledgeTest/EditableTableForKnoweledgeTest";
import ModalWindowAddUser from "../../../../components/knowledgeTestComponents/recordTrainedUsersComponents/modalWindowAddUser/ModalWindowAddUser";
import NotificationWindow from "../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";
import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";
import {
  API_GET_RECORD_TRAINED_USER,
  API_SAVE_CHANGE_RECORD_TRAINED_USER,
  API_SAVE_RECORD_TRAINED_USERS,
  MAIN_URL,
  PORT_FOR_TRAINING,
} from "../../../../constants/constants";

function CardRecordTrainedUsers() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode, userId } = location.state || {};
  const [mainData, setMainData] = useState({ dataForTable: [] });
  const [errorResultForModalWindow, setErrorResultForModalWindow] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [inputOptions, setInputOptions] = useState(getOptionsInputsRecordTrainedUsers());
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [messageNotificationWindow, setMessageNotificationWindow] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [directoryLoad, setDirectoryLoad] = useState(false);
  const [showModalWindow, setShowModalWindow] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const optionsForSelectTrainingProgram = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.trainingProgramLibrary.map((item) => {
      return {
        value: item.id,
        label: item.sign,
        key: "trainingProgId",
      };
    });
  });
  const optionsForSelectTrainingOrganizations = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.allTrainingOrganizations;
  });

  const handleSaveModal = (data) => {
    const delimiter = /[.-]/g;
    data.id = data.id ? data.id : uuidv4();
    data.docAboutEducation = "";
    data.fio = `${data.surname} ${data.name} ${data.midname ? data.midname : ""}`;
    if (data.birthDate && !data.birthDate.includes(".")) {
      const [year, month, day] = data.birthDate.split(delimiter);
      data.birthDateTable = `${day}.${month}.${year}`;
    }
    if (data.trainingDocumentsDateStart && !data.trainingDocumentsDateStart.includes(".")) {
      const [year, month, day] = data.trainingDocumentsDateStart.split(delimiter);
      data.trainingDocumentsDateStartTable = `${day}.${month}.${year}`;
    }
    if (data.trainingDocumentsDateEnd && !data.trainingDocumentsDateEnd.includes(".")) {
      const [year, month, day] = data.trainingDocumentsDateEnd.split(delimiter);
      data.trainingDocumentsDateEndTable = `${day}.${month}.${year}`;
    }
    if (data.trainingDocumentsDocTypeId) {
      if (typeof data.trainingDocumentsDocTypeId === "object") {
        data.trainingDocumentsDocTypeIdName = data.trainingDocumentsDocTypeId.label;
        data.trainingDocumentsDocTypeId = data.trainingDocumentsDocTypeId.value;
      }
    }

    if (data.birthPlace) {
      if (typeof data.birthPlace === "object") {
        data.birthPlaceName = data.birthPlace.label;
        data.birthPlace = data.birthPlace.value;
      }
    }

    if (data.trainingDocumentsDocTypeId || data.trainigDocumentDocNum || data.trainingDocumentDocDate) {
      if (data.trainingDocumentsDocTypeId) {
        data.docAboutEducation += "" + data.trainingDocumentsDocTypeIdName;
      }
      if (data.trainigDocumentDocNum) {
        data.docAboutEducation += " " + data.trainigDocumentDocNum;
      }
      if (data.trainingDocumentDocDate && !data.trainingDocumentDocDate.includes(".")) {
        const [year, month, day] = data.trainingDocumentDocDate.split(delimiter);
        data.docAboutEducation += " " + `${day}.${month}.${year}`;
      }
    }
    for (const prop in data) {
      if (data[prop] === undefined) {
        delete data[prop];
      }
    }

    if (mode === "add") {
      if (clickedButtonType === "add") {
        if (
          mainData.dataForTable.some(
            (el) =>
              (el.fio === data.fio && el.birthDate === data.birthDate) ||
              (data.persNum && el.persNum && el.persNum === data.persNum),
          )
        ) {
          setShowNotificationWindow(true);
          setMessageNotificationWindow(
            "Одного гражданина  по 1  программе подготовки можно добавить только 1  раз. Гражданин с такими данными уже внесен в таблицу. ",
          );
          setErrorResultForModalWindow(true);
          return;
        } else {
          mainData.dataForTable.push({ ...data });
        }
      } else {
        mainData.dataForTable = mainData.dataForTable.map((el) => {
          if (el.id === data.id) {
            return { ...data };
          }
          return el;
        });
      }
    } else {
      mainData.dataForTable = [data];
    }
    setDataModal(null);
    setClickedButtonType("");
    setShowModalWindow(!showModalWindow);
  };
  const handleTableDataUpdate = (tableData) => {
    setMainData({ ...mainData, dataForTable: tableData });
  };
  const resolveSubmit = async (data) => {
    const dataForJSON = mainData.dataForTable.map((el) => {
      el.trainingOrg = data.trainingOrg || mainData.trainingOrg;
      el.trainingProgId = data.trainingProgId || mainData.trainingProgId;
      return el;
    });
    const json = JSON.stringify(dataForJSON);

    let response = null;
    if (mode === "add") {
      response = await fetchWithToken(MAIN_URL + PORT_FOR_TRAINING + API_SAVE_RECORD_TRAINED_USERS, {
        method: "POST",
        body: json,
      });
    }
    if (mode === "edit") {
      response = await fetchWithToken(
        MAIN_URL + PORT_FOR_TRAINING + API_SAVE_CHANGE_RECORD_TRAINED_USER + String(userId),
        {
          method: "POST",
          body: json,
        },
      );
    }
    if (response) {
      const responseData = await response.text();
      if (response.ok) {
        setErrorResultForModalWindow(false);
      } else {
        setErrorResultForModalWindow(true);
      }
      setMessageNotificationWindow(responseData);
      setShowNotificationWindow(!showNotificationWindow);
    }
  };
  const handleButtonAdd = async (e) => {
    e.preventDefault();
    setShowModalWindow(!showModalWindow);
    setClickedButtonType(e.currentTarget.id);
  };

  const handleButtonEdit = async (e) => {
    e.preventDefault();
    setClickedButtonType(e.currentTarget.id);
    setShowModalWindow(!showModalWindow);
  };

  const handleClickTable = (data) => {
    setClickedButtonType("");
    setDataModal({
      ...data,
      id: data.id,
      trainingDocumentsDocTypeId: {
        value: data.trainingDocumentsDocTypeId,
        label: data.trainingDocumentsDocTypeIdName,
      },
      birthPlace: {
        value: data.birthPlace,
        label: data.birthPlaceName,
      },
    });
  };
  const handleClose = (e) => {
    if (e) e.preventDefault();

    if ((e && e.currentTarget.id === "close") || !errorResultForModalWindow) {
      navigate(-1);
    } else {
      setShowNotificationWindow(!showNotificationWindow);
    }
  };
  useEffect(() => {
    async function fetchData() {
      const response = await fetchWithToken(
        MAIN_URL + PORT_FOR_TRAINING + API_GET_RECORD_TRAINED_USER + String(userId),
      );
      if (response.status !== 200) {
        const responseData = await response.text();
        setMessageNotificationWindow(responseData);
        setShowNotificationWindow(!showNotificationWindow);
      } else {
        const dataStatement = await response.json();
        setOptionsInputsRecordTrainedUsers("disabled", true);
        setInputOptions(getOptionsInputsRecordTrainedUsers());
        setMainData(dataStatement);

        setIsLoading(false);
      }
    }
    switch (mode) {
      case "add":
        setIsLoading(false);
        break;
      default:
        fetchData();
    }
  }, []);

  useEffect(() => {
    if (directoryLoad) {
      setOptionsInputsRecordTrainedUsers("firstInit", {
        trainingPrograms: optionsForSelectTrainingProgram,
        trainingOrganization: optionsForSelectTrainingOrganizations,
      });
      if (mode !== "add") {
        setOptionsInputsRecordTrainedUsers("disabled", true);
      }
      setInputOptions(getOptionsInputsRecordTrainedUsers());
    }
  }, [directoryLoad, mode]);

  useEffect(() => {
    if (
      Boolean(optionsForSelectTrainingOrganizations.length) &&
      Boolean(optionsForSelectTrainingProgram.length) &&
      !directoryLoad
    ) {
      setDirectoryLoad(true);
    }
  }, [optionsForSelectTrainingProgram, optionsForSelectTrainingOrganizations]);

  useEffect(() => {
    if (clickedButtonType) {
      clickedButtonType === "add" && setDataModal(null);
    }
  }, [clickedButtonType]);

  if (isLoading) {
    return (
      <div className={"d-flex flex-column align-items-center"}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }

  return (
    <div className={styles["content-container"]}>
      <h2 className={styles["main-text"]}>
        {window.location.pathname.includes("add")
          ? "Добавить граждан, прошедших обучение управлению судами не в ГИМС"
          : window.location.pathname.includes("edit")
          ? "Редактировать граждан, прошедших обучение управлению судами не в ГИМС"
          : "Просмотр граждан, прошедших обучение управлению судами не в ГИМС"}
      </h2>
      <form
        className={styles["form-container"]}
        onSubmit={handleSubmit(resolveSubmit)}>
        {mode === "add" ? (
          <div className={styles["header-block"]}>
            {Object.values(inputOptions).map((option) => {
              switch (true) {
                case option.type === "selectWithSearch": {
                  return (
                    <div className={styles[`box-${option.key}`]}>
                      <SelectWithSearch
                        mode={mode}
                        inputProps={option}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        dataForm={mainData}
                      />
                    </div>
                  );
                }
                default:
                  return (
                    <div className={styles[`box-${option.key}`]}>
                      <InputForForm
                        mode={mode}
                        register={register}
                        inputProps={option}
                        errors={errors}
                        setValue={setValue}
                        dataForm={mainData}
                      />
                    </div>
                  );
              }
            })}
          </div>
        ) : (
          <div className={styles["view-block"]}>
            {Object.values(inputOptions).map((option) => (
              <div className={styles["text-block"]}>
                <p className={styles["option-label"]}>{option.label}</p>
                <p className={styles["option-value"]}>
                  {option.type === "selectWithSearch"
                    ? option.options.find((elem) => elem.value === mainData?.[option.key])?.label || "—"
                    : option.type === "date" && mainData?.[option.key]
                    ? mainData?.[option.key].split("-").reverse().join(".")
                    : mainData?.[option.key] || "—"}
                </p>
              </div>
            ))}
          </div>
        )}

        <div className={styles["buttons-main-block"]}>
          {mode === "add" && (
            <button
              id={`add`}
              title={"Добавить прошедшего обучение"}
              className={styles["add-btn"]}
              onClick={(e) => handleButtonAdd(e)}>
              <span className={styles["plus-icon"]}></span>
              <p className={styles["buttons-text"]}>Добавить прошедшего обучение</p>
            </button>
          )}
          {mode !== "view" && (
            <button
              disabled={!(mainData?.dataForTable?.length && dataModal)}
              id={`edit`}
              title={"Редактировать"}
              className={styles["add-btn"]}
              onClick={(e) => handleButtonEdit(e)}>
              <p className={styles["buttons-text"]}>Редактировать</p>
            </button>
          )}
        </div>
        <EditableTableForKnoweledgeTest
          mode={mode}
          columns={columnsRecordTrainedUsersTable}
          handleTableDataUpdate={handleTableDataUpdate}
          tableData={[...mainData.dataForTable]}
          caption={""}
          tableClick={handleClickTable}
          modalData={dataModal}
        />
        <div className={styles["buttons-block"]}>
          <div
            className={styles["close-btn"]}
            id={"close"}
            onClick={(e) => handleClose(e)}>
            Закрыть
          </div>
          {mode !== "view" && Boolean(mainData.dataForTable.length) && (
            <button className={styles["save-btn"]}>Сохранить</button>
          )}
        </div>
      </form>
      {showModalWindow && (
        <ModalWindowAddUser
          mode={mode}
          handleSave={handleSaveModal}
          dataModal={dataModal}
          modalTitle={captionsForModalWindow[mode]}
          show={showModalWindow}
          setShowWindow={setShowModalWindow}
          setDataModal={setDataModal}
        />
      )}
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={messageNotificationWindow}
        onClose={handleClose}
      />
    </div>
  );
}

export default CardRecordTrainedUsers;
